import React from 'react';
import {Stack} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';
import Skeleton from '@/components/skeleton';

interface ProjectGroupSkeletonProps {
  rowsCount?: number;
}

// Different width variations for skeleton rows to make them look more realistic
const ROW_VARIATIONS = [
  {
    nameWidth: 150,
    progressWidth: 200,
  },
  {
    nameWidth: 120,
    progressWidth: 180,
  },
  {
    nameWidth: 180,
    progressWidth: 220,
  },
];

function ProjectGroupSkeleton({rowsCount = 3}: ProjectGroupSkeletonProps) {
  return (
    <Stack
      direction="column"
      borderBottom={`1px solid ${designSystemToken('semantic.bg.tertiary')}`}
      paddingY="16px"
      gap="8px"
    >
      {/* Project rows skeleton */}
      <Stack direction="column" gap="8px">
        {Array.from({length: rowsCount}).map((_, index) => {
          const variation = ROW_VARIATIONS[index % ROW_VARIATIONS.length];

          return (
            <Stack
              /* eslint-disable-next-line react/no-array-index-key */
              key={index}
              direction="row"
              justifyContent="space-between"
              paddingY="12px"
            >
              {/* Thumbnail skeleton */}
              <Skeleton
                variant="rounded"
                width={40}
                height={40}
                backgroundColor={designSystemToken('semantic.bg.alpha')}
                borderRadius="8px"
              />

              {/* Project info skeleton */}
              <Stack
                direction="column"
                flex={1}
                paddingX="16px"
                justifyContent="center"
                gap="4px"
              >
                {/* Project name skeleton */}
                <Skeleton
                  variant="rectangular"
                  width={variation.nameWidth}
                  height={16}
                  backgroundColor={designSystemToken('semantic.bg.alpha')}
                />
                {/* Project progress skeleton */}
                <Skeleton
                  variant="rectangular"
                  width={variation.progressWidth}
                  height={14}
                  backgroundColor={designSystemToken('semantic.bg.alpha')}
                />
              </Stack>

              {/* Action button skeleton */}
              <Skeleton
                variant="circular"
                width={24}
                height={24}
                backgroundColor={designSystemToken('semantic.bg.alpha')}
              />
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
}

export default ProjectGroupSkeleton;
